<main class="auth-page">
  <section class="auth-shell" aria-labelledby="confirmation-title">
    <div class="auth-shell__accent"></div>
    <div class="auth-content">
      <a class="auth-brand" routerLink="/login" aria-label="GarageDigital"
        ><img src="assets/images/GD_Logotipo_UI.png" alt="GarageDigital"
      /></a>
      <div
        class="auth-icon"
        [ngClass]="{
          'auth-icon--success': state === states.SUCCESS,
          'auth-icon--error':
            state === states.INVALID || state === states.ERROR,
          'auth-icon--warning':
            state === states.EXPIRED ||
            state === states.USED ||
            state === states.MISSING,
        }"
      >
        <i
          class="bi"
          [ngClass]="
            state === states.LOADING
              ? 'bi-hourglass-split'
              : state === states.SUCCESS
                ? 'bi-patch-check'
                : 'bi-envelope-exclamation'
          "
        ></i>
      </div>
      <header class="auth-heading">
        <h1 gdClarityUnmask id="confirmation-title">Confirmación de correo</h1>
        <p *ngIf="state === states.LOADING">
          Estamos verificando tu enlace de confirmación…
        </p>
        <p *ngIf="state === states.SUCCESS">
          Tu correo fue confirmado correctamente. Tu cuenta ya está lista para
          usar.
        </p>
        <p *ngIf="state === states.MISSING">
          El enlace no contiene un token de confirmación.
        </p>
        <p *ngIf="state === states.INVALID">
          El enlace de confirmación no es válido.
        </p>
        <p *ngIf="state === states.EXPIRED">
          El enlace venció. Podés solicitar uno nuevo.
        </p>
        <p *ngIf="state === states.USED">Este enlace ya fue utilizado.</p>
        <p *ngIf="state === states.ERROR">
          No pudimos confirmar el correo. Intentá nuevamente.
        </p>
      </header>
      <a
        *ngIf="state === states.SUCCESS"
        class="auth-button"
        routerLink="/login"
        ><i class="bi bi-box-arrow-in-right"></i> Ingresar a GarageDigital</a
      >
      <form *ngIf="canResend" (ngSubmit)="resend()" class="auth-form">
        <div class="auth-field">
          <label for="resend-email">Correo electrónico</label>
          <div class="auth-input">
            <i class="bi bi-envelope"></i
            ><input
              id="resend-email"
              name="email"
              class="form-control"
              type="email"
              [(ngModel)]="email"
              placeholder="nombre@correo.com"
              autocomplete="email"
              required
            />
          </div>
        </div>
        <button class="auth-button auth-button--outline" [disabled]="resending">
          <gd-inline-spinner *ngIf="resending" size="sm" tone="current" /><i
            *ngIf="!resending"
            class="bi bi-arrow-clockwise"
          ></i
          >{{ resending ? "Reenviando…" : "Reenviar correo" }}
        </button>
      </form>
      <a *ngIf="state !== states.SUCCESS" routerLink="/login" class="auth-back"
        ><i class="bi bi-arrow-left"></i> Volver al inicio de sesión</a
      >
    </div>
  </section>
</main>
